const STORAGE_KEY = 'theme';
const MODES = ['system', 'light', 'dark'];
const DARK_QUERY = '(prefers-color-scheme: dark)';

const readStoredMode = () => {
  try {
    const mode = window.localStorage.getItem(STORAGE_KEY);
    return MODES.includes(mode) ? mode : null;
  } catch {
    return null;
  }
};

export const currentMode = () =>
  readStoredMode() ||
  document.documentElement.dataset.hcModeDefault ||
  MODES[0];

export const resolveMode = mode => {
  if (mode !== 'system') return mode;
  return window.matchMedia(DARK_QUERY).matches ? 'dark' : 'light';
};

export const syncThemeControls = (mode = currentMode()) => {
  document.querySelectorAll('[data-hc-theme-option]').forEach(option => {
    option.setAttribute(
      'aria-pressed',
      String(option.dataset.hcThemeOption === mode)
    );
  });
};

export const applyMode = (mode = currentMode()) => {
  const root = document.documentElement;
  root.dataset.hcTheme = mode;
  root.classList.remove('light', 'dark');
  root.classList.add(resolveMode(mode));
  syncThemeControls(mode);
};

const dropThemeParam = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('theme')) return;
  url.searchParams.delete('theme');
  window.history.replaceState(window.history.state, '', url.toString());
};

const storeMode = mode => {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
    return true;
  } catch {
    return false;
  }
};

export const setMode = mode => {
  if (!MODES.includes(mode)) return;
  storeMode(mode);
  applyMode(mode);
  dropThemeParam();
};

export const initTheme = () => {
  document.addEventListener('click', event => {
    const option = event.target.closest('[data-hc-theme-option]');
    if (option) setMode(option.dataset.hcThemeOption);
  });
  window.matchMedia(DARK_QUERY).addEventListener('change', () => {
    if (currentMode() === 'system') applyMode('system');
  });
};
